// Configuration i18next (fr/en, défaut anglais, vouvoiement en FR).
// Détection initiale : locale du navigateur → fr si fr-*, sinon en. La ressource
// est bundlée (pas de fetch runtime) — parité des clés garantie par scripts/check-i18n.ts.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import frCommon from './locales/fr/common.json';

export const SUPPORTED_LOCALES = ['fr', 'en'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'en';
export const DEFAULT_NS = 'common';

export const resources = {
  fr: { common: frCommon },
  en: { common: enCommon },
} as const;

// Détection : fr-* → fr, sinon en. Surchargée ensuite par le choix persisté / le profil.
export function detectLocale(): Locale {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;
  const lang = navigator.language?.toLowerCase() ?? '';
  return lang.startsWith('fr') ? 'fr' : 'en';
}

let initialized = false;

export function initI18n(locale?: Locale): typeof i18n {
  if (!initialized) {
    void i18n.use(initReactI18next).init({
      resources,
      lng: locale ?? DEFAULT_LOCALE,
      fallbackLng: DEFAULT_LOCALE,
      defaultNS: DEFAULT_NS,
      ns: [DEFAULT_NS],
      interpolation: { escapeValue: false }, // React échappe déjà
      returnNull: false,
    });
    initialized = true;
  }
  return i18n;
}

export default i18n;
